import React from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
// @mui
import { Stack, Typography, Link } from '@mui/material';

import RegisterForm from "../../sections/auth/RegisterForm";
//import SignInwithGoogle from '../../sections/auth/signInWIthGoogle';

// ----------------------------------------------------------------------

export default function Register() {
  const navigate=useNavigate();
  return (
    <>
      <Stack spacing={2} sx={{ mb: 5, position: 'relative' }}>
        <Typography variant="h4">Get started with GemX.</Typography>

        <Stack direction="row" spacing={0.5}>
          <Typography variant="body2"> Already have an account? </Typography>

          <Link component={RouterLink} to={"/auth/login"} variant="subtitle2">
            Sign in
          </Link>
        </Stack>
      </Stack>
      {/* Form */}
      <RegisterForm  />

      <Typography
        component="div"
        sx={{ color: 'text.secondary', mt: 3, typography: 'caption', textAlign: 'center' }}
      >
        {'By signing up, I agree to '}
        <Link sx={{cursor:'pointer'}} underline="always" color="text.primary" onClick={()=>navigate('/auth/termsandCondition')}>
          Terms of Service
        </Link>
        {' and '}
        <Link sx={{cursor:'pointer'}} underline="always" color="text.primary" onClick={()=>navigate('/auth/privacyPolicy')}>
          Privacy Policy
        </Link>
        .
      </Typography>

     {/* <SignInwithGoogle /> */}
      </>
  );
}
